var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.userCredits },
    [
      _vm.isLoggedIn
        ? _c("p", [
            _vm._v("\n    " + _vm._s(_vm.$t("navBar.youhave")) + "\n    "),
            _c("span", { class: _vm.$style.credits }, [
              _vm._v(_vm._s(_vm.credits)),
            ]),
            _vm._v("\n    " + _vm._s(_vm.$t("navBar.credits")) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c("PageControl", { attrs: { href: "/shop/credits", primary: "" } }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("navBar.buyCreditsMenuButton")) + "\n  "
            ),
          ])
        : _c("PageControl", { attrs: { href: "/login", primary: "" } }, [
            _vm._v("\n    " + _vm._s(_vm.$t("navBar.loginButton")) + "\n  "),
          ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }